module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_8011.1cbcb066.png";